import PropTypes from 'prop-types';

import APP from 'constants/app';

const ROLES = ['presentation', 'img'];
const VIEW_BOX = '0 0 24 24';
/**
 * These sheets are auto-generated by a Webpack plugin that you can found your
 * definitions at `next.config.js`.
 */
const AVAILABLE_SHEETS = [
  'spritemap',
  'blog-categories-carousel',
  'forum-categories-carousel',
];

const SpriteSheet = ({
  'aria-hidden': ariaHidden,
  className,
  icon,
  role = 'presentation',
  sheet,
  title,
}) => (
  <svg
    aria-hidden={ariaHidden}
    className={className}
    role={role}
    viewBox={VIEW_BOX}
  >
    {title && <title>{title}</title>}
    <use
      xlinkHref={`${APP.LOCAL_IMAGE_PATH}/sprites/${sheet}.svg?b=${process.env.BUILD_ID}#sprite-${icon}`}
    />
  </svg>
);

SpriteSheet.propTypes = {
  /**
   * Indicates whether the icon is available as an accessible element.
   */
  'aria-hidden': PropTypes.bool,
  /**
   * Name of icon that to be rendered
   */
  icon: PropTypes.string.isRequired,
  /**
   * **DEVELOPMENT USE ONLY**
   *
   * Change the representation of icon in window. Default is `presentation`
   */
  role: PropTypes.oneOf(ROLES),
  /**
   * Name of icon that to be rendered
   */
  sheet: PropTypes.oneOf(AVAILABLE_SHEETS).isRequired,
  /**
   * **DEVELOPMENT USE ONLY**
   *
   * Set the icon title for accessibility
   */
  title: PropTypes.string,
};

export default SpriteSheet;
